import React from 'react';
import { ClientFormData } from './ClientFormData';

interface ClientFormModalProps {
  show?: boolean;
  onClose: () => void;
  parameter?: string;
}

export function ClientFormModal({
  show,
  onClose,
  parameter = '',
}: ClientFormModalProps): JSX.Element {
  const isNumber = /^\d+$/.test(parameter);

  return (
    <div className="news-modal" style={{ display: show ? 'block' : 'none' }}>
      <div
        className="modal fade"
        tabIndex={-1}
        id="modalDefault"
        style={{ display: 'block', opacity: 1 }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Novo Cliente</h5>
              <div role="button" className="close" onClick={onClose}>
                <em className="icon ni ni-cross" />
              </div>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: '80vh', overflow: 'scroll' }}
            >
              <ClientFormData
                name={!isNumber ? parameter : ''}
                phoneNumber={isNumber ? parameter : ''}
                onClose={onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
